import styled from "styled-components";

export const ProfileCashierButtonDefaultBox = styled.div`
    display: block;
    position: relative;
    line-height: 2.7;
    cursor: pointer;
    font-size: 1.4rem;
    font-weight: 700;
    text-align: center;
    text-decoration: none;

    background-color: ${({theme}) => theme.colors.bodyBackground};
    transition: all 0.2s ease-in-out;
    border-style: solid;
    border-width: 2px;
    border-radius: 50px;
    padding: 0 1rem 0 0;
    text-transform: none;
    opacity: 0.8;
    &:hover {
        opacity: 1;
    }
`;
